import { useEffect, useRef, useState } from "react";
import ProcessStepItem from "./ProcessStepItem";
import "../styles/processSteps.css";

/**
 * Row of icon-and-arrow steps describing a process — vertical (icon left,
 * text right, arrows pointing down) below the lg breakpoint, horizontal
 * (icon on top, text centered below, arrows pointing right) at lg and up.
 * Fades + rises into view once scrolled into the viewport, each step
 * staggered slightly after the previous one.
 *
 * @param {{steps: {icon: object, title: import("react").ReactNode, description: import("react").ReactNode}[], className?: string}} props
 */
export default function ProcessSteps({ steps, className = "" }) {
  const wrapperRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (wrapperRef.current) observer.observe(wrapperRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`steps-wrapper d-flex flex-column flex-lg-row gap-3 align-items-start align-items-lg-start justify-content-start justify-content-lg-center${
        isVisible ? " is-visible" : ""
      }${className ? ` ${className}` : ""}`}
    >
      {steps.map((step, index) => (
        <ProcessStepItem
          key={`${step.title}-${index}`}
          step={step}
          isFirst={index === 0}
          isLast={index === steps.length - 1}
        />
      ))}
    </div>
  );
}
